import ComponentLayout from '~/src/layouts/component-layout';
import { Box } from '@primer/react';
import { Caption } from '@primer/gatsby-theme-doctocat';
import * as React from 'react';
export default {
  ComponentLayout,
  Box,
  Caption,
  React
};